import { render, staticRenderFns } from "./SmsObserverForm.vue?vue&type=template&id=962198f4"
import script from "./SmsObserverForm.vue?vue&type=script&lang=js"
export * from "./SmsObserverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports